import { createContext, useContext } from "react";

import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

const BentoTransparentContext = createContext(false);

/** Wrap children so all nested BentoCards render transparent & borderless. */
export function BentoTransparentProvider({ children }: { children: ReactNode }) {
  return (
    <BentoTransparentContext.Provider value={true}>
      {children}
    </BentoTransparentContext.Provider>
  );
}

interface BentoCardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  shadow?: boolean;
}

export function BentoCard({ children, className, hover = false, shadow = false }: BentoCardProps) {
  const transparent = useContext(BentoTransparentContext);
  return (
    <div
      className={cn(
        // Landing card language: soft shadows and hairline borders,
        // never black borders or hard offset shadows.
        "flex min-w-0 flex-col overflow-hidden rounded-2xl transition-all duration-200",
        transparent
          ? "border border-white/10 bg-white/5 backdrop-blur-sm"
          : "border border-black/5 bg-white shadow-[0_6px_16px_-12px_rgba(0,0,0,0.35)] dark:border-white/10 dark:bg-surface-dark-card",
        shadow && "shadow-[0_16px_36px_-18px_rgba(0,0,0,0.4)]",
        hover && !transparent &&
          "hover:-translate-y-0.5 hover:shadow-[0_14px_30px_-16px_rgba(0,0,0,0.45)]",
        className,
      )}
    >
      {children}
    </div>
  );
}
